import { gql } from '@apollo/client';

export const GET_ACTIVE_LOG_POLLS = gql`
    query getActiveLogPolls {
        uiState @client {
            activeLogPolls
        }
    }
`;
